import api from "../api";

export default {
    index(params) {
        return api.get(`/central/settlements`, { params })
    },
    show(id) {
        return api.get(`/central/settlements/${id}`)
    }
}
